var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('iframe',{attrs:{"src":_vm.horizonUrl,"width":"100%","frameborder":"0","height":"600"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }